// Time constants in milliseconds
export const MS_SECOND = 1_000
export const MS_MINUTE = 60 * MS_SECOND
export const MS_HOUR = 60 * MS_MINUTE
export const MS_24H = 24 * MS_HOUR

// Specific intervals
export const AUTO_REFRESH_INTERVAL_MS = MS_MINUTE
export const MS_60S = 60 * MS_SECOND // Optional: could be removed if it's the same as MS_MINUTE
